import CenteredMessage from '../layout/CenteredMessage';


export default function NoResults() {
    return <CenteredMessage>No results match your search.</CenteredMessage>;
}
